import { createContext, useContext, type ReactNode } from 'react';
import type { Me, Org, Role } from './types';

export interface Session {
  me: Me;
  org: Org;
  currency: string;
  can: (role: Role) => boolean;
}

const RANK: Record<Role, number> = { VIEWER: 0, ACCOUNTANT: 1, ADMIN: 2, OWNER: 3 };
export const roleAtLeast = (have: Role, need: Role) => RANK[have] >= RANK[need];

const SessionContext = createContext<Session | null>(null);

export function SessionProvider({ me, org, children }: { me: Me; org: Org; children: ReactNode }) {
  const value: Session = { me, org, currency: org.baseCurrency, can: (r) => roleAtLeast(me.role, r) };
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession(): Session {
  const s = useContext(SessionContext);
  if (!s) throw new Error('useSession outside SessionProvider');
  return s;
}
